import { cloneElement } from "react";
import { DATA_EXIT_CONTAINER } from "./constants";

var ExitContainer = function ExitContainer(_ref) {
  var _cloneElement;

  var children = _ref.children;

  return cloneElement(children, (_cloneElement = {}, _cloneElement[DATA_EXIT_CONTAINER] = true, _cloneElement));
};

export default ExitContainer;